export default "__VITE_ASSET__99a63f3b__"